import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants';

const initialState = {
  // Payments
  current: {},
  fetchingCurrent: false,
  payments: [],
  fetchingPayments: false,
  // Payment methods
  fetchPaymentMethods: FETCH_STATE.UNSENT,
  fetchAddPaymentMethod: FETCH_STATE.UNSENT,
  fetchDeletePaymentMethod: FETCH_STATE.UNSENT,
  fetchUpdatePaymentMethod: FETCH_STATE.UNSENT,
  paymentMethods: [],
  pagination: {},
};

const paymentReducer = createReducer(initialState)({
  [types.FETCH_PAYMENT_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      fetchingCurrent: true,
    };
  },
  [types.FETCH_PAYMENT_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingCurrent: false,
      current: payload,
    };
  },
  [types.FETCH_PAYMENT_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      fetchingCurrent: false,
    };
  },

  [types.FETCH_PAYMENTS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingPayments: true,
    };
  },
  [types.FETCH_PAYMENTS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingPayments: false,
      payments: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_PAYMENTS_FAILED]: (state) => {
    return {
      ...state,
      fetchingPayments: false,
    };
  },

  //PAYMENT METHODS
  [types.FETCH_PAYMENT_METHODS_REQUEST]: (state) => {
    return {
      ...state,
      paymentMethods: [],
      pagination: {},
      fetchPaymentMethods: FETCH_STATE.LOADING,
      fetchAddPaymentMethod: FETCH_STATE.UNSENT,
      fetchDeletePaymentMethod: FETCH_STATE.UNSENT,
      fetchUpdatePaymentMethod: FETCH_STATE.UNSENT,
    };
  },
  [types.FETCH_PAYMENT_METHODS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      paymentMethods: payload.data,
      pagination: payload.pagination,
      fetchPaymentMethods: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_PAYMENT_METHODS_FAILED]: (state) => {
    return {
      ...state,
      fetchPaymentMethods: FETCH_STATE.ERROR,
    };
  },

  // ADD PAYMENT METHOD
  [types.FETCH_ADD_PAYMENT_METHOD_REQUEST]: (state) => {
    return {
      ...state,
      fetchAddPaymentMethod: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_ADD_PAYMENT_METHOD_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      paymentMethod: payload,
      fetchAddPaymentMethod: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_ADD_PAYMENT_METHOD_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchAddPaymentMethod: FETCH_STATE.ERROR,
      errors,
    };
  },

  // RESET PAYMENT METHODS
  [types.RESET_FETCH_PAYMENT_METHODS]: (state) => ({
    ...state,
    fetchPaymentMethods: FETCH_STATE.UNSENT,
    fetchAddPaymentMethod: FETCH_STATE.UNSENT,
    fetchDeletePaymentMethod: FETCH_STATE.UNSENT,
    fetchUpdatePaymentMethod: FETCH_STATE.UNSENT,
  }),

  // DELETE PAYMENT METHOD
  [types.FETCH_DELETE_PAYMENT_METHOD_REQUEST]: (state) => {
    return {
      ...state,
      fetchDeletePaymentMethod: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_DELETE_PAYMENT_METHOD_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchDeletePaymentMethod: FETCH_STATE.DONE,
      paymentMethod: payload,
    };
  },
  [types.FETCH_DELETE_PAYMENT_METHOD_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchDeletePaymentMethod: FETCH_STATE.ERROR,
      errors,
    };
  },
  // UPDATE PAYMENT METHOD
  [types.FETCH_UPDATE_PAYMENT_METHOD_REQUEST]: (state) => {
    return {
      ...state,
      fetchUpdatePaymentMethod: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_UPDATE_PAYMENT_METHOD_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchUpdatePaymentMethod: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_UPDATE_PAYMENT_METHOD_FAILED]: (state) => {
    return {
      ...state,
      fetchUpdatePaymentMethod: FETCH_STATE.ERROR,
    };
  },
});

export default paymentReducer;
